import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { Table } from 'primeng/table';
import { TProductoSolicitudViewModel } from '../../../_importacion/solicitudes/productos/productos.types';
import { TPreduaMantenimientoViewModel, TPosicionamientoPreduaMantenimientoViewModel, TPartidaPreduaMantenimientoViewModel } from './mrn.types';
import { MrnService } from './mrn.service';

@Component({
    selector: 'app-mrn-edit',
    templateUrl: './mrn-edit.component.html',
})
export class MrnEditComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    EsSolicitante: boolean = true;
    NombreInspector: string = '';
    predua: TPreduaMantenimientoViewModel;
    partidas: TPartidaPreduaMantenimientoViewModel[];
    strMatriculas: string = '';
    posicionamientopredua: TPosicionamientoPreduaMantenimientoViewModel[];
    mrn: string = '';
    _acumulado: number = 0;
    _parametros: string = '';
    listOperacion: Tc[];
    listSolicitudPartidasPreduaCollection: TProductoSolicitudViewModel[];

    IdEstadoSolicitud: number;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    TipoSolicitudDescripcion: string;
    EstadoSolicitudDescripcion: string;
    EsPredua: boolean = false;

    cols: any[];
    public selectedColumns: any[];

    public isCollapsedExportador = false;
    public isCollapsedImportador = false;
    public isCollapsedLugaresMercancia = false;
    public isCollapsedOtrosDatos = false;
    public isCollapsedDatosPreDua = false;
    public isCollapsedContenedores = false;
    public isCollapsedPartidasPreDua = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private mrnService: MrnService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.predua = new TPreduaMantenimientoViewModel();
    }

    ngOnInit() {
        this.cols = [
            //{ field: 'ExpandLink', header: '' },
            //{ field: 'Link', header: '' },
            { field: 'Partida', header: 'Partida' },
            { field: 'CodigoTaric', header: 'Código Taric' },
            { field: 'PaisOrigen', header: 'País Origen' },
            //{ field: 'PesoNeto', header: 'Peso (kg)' },
            //{ field: 'Acumulado', header: 'Acumulado' },
            //{ field: 'DescripcionMercancia', header: 'Descripción Mercancía' },
            //{ field: 'strMatriculas', header: 'Matrí­culas' },
        ];

        this.selectedColumns = this.cols;

        this.globalService.getTipoOperacionAduanas().subscribe(res => {
            this.listOperacion = res;
        });

        let mrn = this.activatedRoute.snapshot.params.mrn;

        this.createForm();

        if (mrn) {
            this.loading = true;

            //recuperar el Predua
            this.mrnService.getPreduaByMrn(mrn.toString()).subscribe(result => {
                this.predua = result;

                this.predua.TPartidasPreduaList.forEach(s => {
                    let first: boolean = true;
                    this.strMatriculas = '';

                    s.MatriculasList.forEach(t => {
                        //Matrí­culas
                        if (!first) {
                            this.strMatriculas += ', ' + t.Matricula;
                        } else {
                            this.strMatriculas += t.Matricula;
                            first = false;
                        }
                    });
                });

                this.partidas = this.predua.TPartidasPreduaList;
                this.updateForm();
                this.form.controls['IdOperacion'].disable();
                this.posicionamientopredua = result.TPosicionamientoPreduaList;
                this.loading = false;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            Mrn: '',
            IdOperacion: null,
            IdPif: null,
            IdPifDescripcion: '',
            IdAduanaDespacho: null,
            IdAduanaDespachoDescripcion: '',
            NombreExportador: '',
            PaisExportador: null,
            CiudadExportador: '',
            DireccionExportador: '',
            IdentificadorImportador: null,
            RazonSocialImportador: '',
            DireccionImportador: '',
            PaisDestino: null,
            PaisOrigen: null,
            MedioTransporte: null,
            FechaCreacion: '',
            FechaModificacion: '',
            FechaImportacion: '',
            FechaPresentacion: '',
        });
    }

    updateForm() {
        this.form.setValue({
            Mrn: this.predua.Mrn,
            IdOperacion: this.predua.IdOperacion,
            IdPif: this.predua.IdPif,
            IdPifDescripcion: this.predua.IdPifDescripcion,
            IdAduanaDespacho: this.predua.IdAduanaDespacho,
            IdAduanaDespachoDescripcion: this.predua.IdAduanaDespachoDescripcion,
            NombreExportador: this.predua.NombreExportador,
            PaisExportador: this.predua.PaisExportador,
            CiudadExportador: this.predua.CiudadExportador,
            DireccionExportador: this.predua.DireccionExportador,
            IdentificadorImportador: this.predua.IdentificadorImportador,
            RazonSocialImportador: this.predua.RazonSocialImportador,
            DireccionImportador: this.predua.DireccionImportador,
            PaisDestino: this.predua.PaisDestino,
            PaisOrigen: this.predua.PaisOrigen,
            MedioTransporte: this.predua.MedioTransporte,
            FechaCreacion: new Date(this.predua.FechaCreacion),
            FechaModificacion: new Date(this.predua.FechaModificacion),
            FechaImportacion: new Date(this.predua.FechaImportacion),
            FechaPresentacion: new Date(this.predua.FechaPresentacion),
        });
    }

    onBack() {
        this.router.navigate(['/mantenimiento/general/mrn']);
    }
}
